var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError } from '@wix/metro-runtime/velo';
import * as ambassadorWixBookingsCatalogV1Resource from '@wix/ambassador-bookings-catalog-v1-resource/http';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var Day;
(function (Day) {
    /** Undefined. */
    Day["UNDEFINED"] = "UNDEFINED";
    /** Monday. */
    Day["MON"] = "MON";
    /** Tuesday. */
    Day["TUE"] = "TUE";
    /** Wednesday. */
    Day["WED"] = "WED";
    /** Thursday. */
    Day["THU"] = "THU";
    /** Friday. */
    Day["FRI"] = "FRI";
    /** Saturday. */
    Day["SAT"] = "SAT";
    /** Sunday. */
    Day["SUN"] = "SUN";
})(Day || (Day = {}));
export var Transparency;
(function (Transparency) {
    Transparency["UNDEFINED"] = "UNDEFINED";
    /** The schedule can have available slots during the session. */
    Transparency["FREE"] = "FREE";
    /** The schedule cannot have available slots during the session. Default value. */
    Transparency["BUSY"] = "BUSY";
})(Transparency || (Transparency = {}));
export var RecurringIntervalType;
(function (RecurringIntervalType) {
    /** The default value. Sessions for this interval will be of type EVENT. */
    RecurringIntervalType["UNDEFINED"] = "UNDEFINED";
    /** A recurring interval of events */
    RecurringIntervalType["EVENT"] = "EVENT";
    /** Deprecated */
    RecurringIntervalType["TIME_AVAILABILITY"] = "TIME_AVAILABILITY";
    /** A recurring interval for availability */
    RecurringIntervalType["AVAILABILITY"] = "AVAILABILITY";
})(RecurringIntervalType || (RecurringIntervalType = {}));
export var LocationType;
(function (LocationType) {
    LocationType["UNDEFINED"] = "UNDEFINED";
    LocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    LocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
    LocationType["CUSTOM"] = "CUSTOM";
})(LocationType || (LocationType = {}));
/** For future use */
export var LocationStatus;
(function (LocationStatus) {
    LocationStatus["ACTIVE"] = "ACTIVE";
    LocationStatus["INACTIVE"] = "INACTIVE";
})(LocationStatus || (LocationStatus = {}));
/** For future use */
export var LocationsLocationType;
(function (LocationsLocationType) {
    LocationsLocationType["UNKNOWN"] = "UNKNOWN";
    LocationsLocationType["BRANCH"] = "BRANCH";
    LocationsLocationType["OFFICES"] = "OFFICES";
    LocationsLocationType["RECEPTION"] = "RECEPTION";
    LocationsLocationType["HEADQUARTERS"] = "HEADQUARTERS";
    LocationsLocationType["INVENTORY"] = "INVENTORY";
})(LocationsLocationType || (LocationsLocationType = {}));
/** Enumerates the days of the week. */
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek["MONDAY"] = "MONDAY";
    DayOfWeek["TUESDAY"] = "TUESDAY";
    DayOfWeek["WEDNESDAY"] = "WEDNESDAY";
    DayOfWeek["THURSDAY"] = "THURSDAY";
    DayOfWeek["FRIDAY"] = "FRIDAY";
    DayOfWeek["SATURDAY"] = "SATURDAY";
    DayOfWeek["SUNDAY"] = "SUNDAY";
})(DayOfWeek || (DayOfWeek = {}));
export var ApprovalStatus;
(function (ApprovalStatus) {
    /** Default. */
    ApprovalStatus["UNDEFINED"] = "UNDEFINED";
    /** Pending business approval. */
    ApprovalStatus["PENDING"] = "PENDING";
    /** Approved by the business. */
    ApprovalStatus["APPROVED"] = "APPROVED";
    /** Declined by the business. */
    ApprovalStatus["DECLINED"] = "DECLINED";
})(ApprovalStatus || (ApprovalStatus = {}));
export var ScheduleStatus;
(function (ScheduleStatus) {
    ScheduleStatus["UNDEFINED"] = "UNDEFINED";
    /** The default value when the schedule is created. */
    ScheduleStatus["CREATED"] = "CREATED";
    /** The schedule has been canceled. */
    ScheduleStatus["CANCELLED"] = "CANCELLED";
})(ScheduleStatus || (ScheduleStatus = {}));
export var ConferenceType;
(function (ConferenceType) {
    ConferenceType["UNDEFINED"] = "UNDEFINED";
    /** API-generated online meeting. */
    ConferenceType["ONLINE_MEETING_PROVIDER"] = "ONLINE_MEETING_PROVIDER";
    /** User-defined meeting. */
    ConferenceType["CUSTOM"] = "CUSTOM";
})(ConferenceType || (ConferenceType = {}));
export var ResourceStatus;
(function (ResourceStatus) {
    ResourceStatus["UNDEFINED"] = "UNDEFINED";
    /** Default status. */
    ResourceStatus["CREATED"] = "CREATED";
    /** The resource was deleted. */
    ResourceStatus["DELETED"] = "DELETED";
    /** The resource was updated. */
    ResourceStatus["UPDATED"] = "UPDATED";
})(ResourceStatus || (ResourceStatus = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var Event;
(function (Event) {
    Event["UNDEFINED"] = "UNDEFINED";
    Event["Updated"] = "Updated";
    Event["Deleted"] = "Deleted";
    Event["Created"] = "Created";
    Event["Schedule_Updated"] = "Schedule_Updated";
})(Event || (Event = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _availability = { locations: '_location' };
const _batchCreateResourceRequest = {
    resources: '_resource',
    batchedResources: '_createResourceRequest',
};
const _batchCreateResourceResponse = { resources: '_resource' };
const _batchDeleteResourceRequest = {};
const _batchDeleteResourceResponse = {};
const _batchRequest = {
    createRequests: '_createScheduleRequest',
    updateRequests: '_updateScheduleRequest',
};
const _batchResponse = {
    created: '_schedule',
    updated: '_schedule',
    cancelled: '_schedule',
};
const _createResourceRequest = {
    resource: '_resource',
    schedules: '_schedule',
};
const _createResourceResponse = { resource: '_resource' };
const _createScheduleRequest = { schedule: '_schedule' };
const _deleteResourceRequest = {};
const _deleteResourceResponse = {};
const _getBusinessResourceRequest = {};
const _getBusinessResourceResponse = { resource: '_resource' };
const _linkResourceToUserRequest = {};
const _linkResourceToUserResponse = { resource: '_resource' };
const _listResourcesRequest = {};
const _listResourcesResponse = { resources: '_resource' };
const _location = { businessLocation: '_locationsLocation' };
const _locationsLocation = { address: 'wix.common.Address' };
const _queryResourcesRequest = {};
const _queryResourcesResponse = { resources: '_resource' };
const _resource = {
    images: 'wix.common.Image',
    schedules: '_schedule',
    eventsSchedule: '_schedule',
};
const _resourceUpdateScheduleRequest = { schedule: '_schedule' };
const _schedule = { location: '_location', availability: '_availability' };
const _unLinkResourceFromOwnerRequest = {};
const _unLinkResourceFromOwnerResponse = { resource: '_resource' };
const _updateResourceRequest = {
    resource: '_resource',
    scheduleActions: '_batchRequest',
};
const _updateResourceResponse = {
    resource: '_resource',
    schedules: '_batchResponse',
};
const _updateScheduleRequest = { schedule: '_schedule' };
const _updateScheduleResponse = { schedule: '_schedule' };
/**
 * @internal
 * @internal
 * @deprecated
 */
export function list(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { query: '$[0].query' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _listResourcesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _listResourcesResponse,
            depSchemas: {
                _availability,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
            },
            fqdnTransformation: {
                paths: [...['Array#resources']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource.list(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a query to retrieve extended resource information.
 *
 * The `queryResources()` function builds a query to retrieve a catalog of resources, including resources' related  schedules and slugs, and returns a [`ResourceQueryBuilder`](#) object. The returned object contains the query definition, which is typically used to run the query using the [`find()`](#) function.
 *
 * The `ResourceQueryBuilder` functions enable you to run, filter, and control which results a query returns.
 *
 * Typically, you build a query using the `queryResources()` function, refine the query by chaining `ResourceQueryBuilder` functions, and then execute the query by chaining the `find()` function.
 *
 * The query runs with the following defaults that you can override:
 * - [`skip`](#): `0`
 * - [`limit`](#): `50`
 *
 * The following query builder functions are supported for `queryResources()`. For a full description of the `Resources` object, see the object returned for the [`items`](#) array in [`ResourceQueryResult`](#).
 * @internal */
export function queryResources(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            query: '$[0].query',
            includeResourcesWithGroups: '$[0].includeResourcesWithGroups',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _queryResourcesRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _queryResourcesResponse,
            depSchemas: {
                _availability,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
            },
            fqdnTransformation: {
                paths: [...['Array#resources']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource.query(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Returns the Business Resource.
 *
 * This endpoint is only implemented in the Resources V2 proxy.
 * When called for a site that is not rolled out to V2 an error is returned.
 * @internal
 * @documentationMaturity preview
 */
export function getBusinessResource() {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {};
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[0];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getBusinessResourceRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getBusinessResourceResponse,
            depSchemas: {
                _availability,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
            },
            fqdnTransformation: {
                paths: [...['resource']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource.getBusinessResource(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, []);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a resource.
 *
 *
 * The `createResource()` function returns a Promise that resolves to the created resource.
 * Bookings resources are created with a schedule. The schedule determines the resource's availability by the business's default working hours.
 *
 * When creating a resource using `createResource()`, get the business resource's schedule ID and include it in the `schedules` object. The default hours can bee found in the Dashboard under **Settings** in the **Bookings** section, on the **Appointment hours** page.
 *
 *
 * > **Notes:**
 * >- The Wix Bookings app shows default business hours on the **Staff** page in the dashboard.
 * >- A resource can have one schedule only.
 * >- You can have up to 135 active resources and an additional 135 deleted resources.
 * @param resource - Resource to create.
 * @public
 * @requiredField options.schedules.availability.start
 * @requiredField options.schedules.intervals.start
 * @requiredField resource
 * @requiredField resource.name
 * @param options - Options for assigning a schedule to a resource.
 * @adminMethod
 * @returns Created resource.
 */
export function createResource(resource, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            resource: '$[0]',
            schedules: '$[1].schedules',
        };
        const responseTransformation = '$.resource';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createResourceRequest,
            depSchemas: {
                _availability,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
            },
            fqdnTransformation: {
                paths: [...['resource']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createResourceResponse,
            depSchemas: {
                _availability,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
            },
            fqdnTransformation: {
                paths: [...['resource']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([resource, options]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource.create(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'resource',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates multiple resources with corresponding schedules.
 * @internal
 * @documentationMaturity preview
 * @adminMethod
 */
export function batchCreate(options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            resources: '$[0].resources',
            batchedResources: '$[0].batchedResources',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _batchCreateResourceRequest,
            depSchemas: {
                _availability,
                _createResourceRequest,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
            },
            fqdnTransformation: {
                paths: [...['Array#resources', 'Array#batchedResources.resource']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _batchCreateResourceResponse,
            depSchemas: {
                _availability,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
            },
            fqdnTransformation: {
                paths: [...['Array#resources']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([options]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource.batchCreate(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a resource.
 *
 *
 * The `updateResource()` function returns a Promise that resolves when a resource is updated. Use this function to update all bookings resource information except for the resource's schedule. To update a resource's schedule use [`updateSchedule()`](#updateschedule).
 *
 *
 * >**Note:**
 * > When updating a resource you cannot change the system tags used by the Wix Bookings app. Tags used by the app have the values `"business"` and `"staff"`.
 * @param _id - Resource ID.
 * @public
 * @requiredField _id
 * @requiredField resource
 * @param resource - Resource to update.
 * @adminMethod
 * @returns Updated resource.
 */
export function updateResource(_id, resource, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            resource: { '*': '$[1]', id: '$[0]' },
            fieldMask: '$[2].fieldMask',
            scheduleActions: '$[2].scheduleActions',
        };
        const responseTransformation = '$.resource';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateResourceRequest,
            depSchemas: {
                _availability,
                _batchRequest,
                _createScheduleRequest,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
                _updateScheduleRequest,
            },
            fqdnTransformation: {
                paths: [...['resource']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateResourceResponse,
            depSchemas: {
                _availability,
                _batchResponse,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
            },
            fqdnTransformation: {
                paths: [...['resource']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, resource, options]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource.update(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'resource',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a resource's schedule.
 *
 *
 * The `updateSchedule()` function returns a Promise that resolves when a resource's schedule has been updated. Use this function to update the bookings resource's schedule. To update other resource details use [`updateResource()`](#updateresource).
 *
 * > **Notes:**
 * >- A resource can have one schedule only.
 * >- When updating a resource's schedule you cannot change the system tags used by the Wix Bookings app. Tags used by the app have the values `"INDIVIDUAL"`, `"GROUP"`, and `"COURSE"`.
 * @param resourceId - Resource ID to update.
 * @param schedule - Schedule to update.
 * @public
 * @requiredField resourceId
 * @requiredField schedule
 * @requiredField schedule._id
 * @adminMethod
 */
export function updateSchedule(resourceId, schedule, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            resourceId: '$[0]',
            schedule: '$[1]',
            fieldmask: '$[2].fieldmask',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _resourceUpdateScheduleRequest,
            depSchemas: { _availability, _location, _locationsLocation, _schedule },
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateScheduleResponse,
            depSchemas: { _availability, _location, _locationsLocation, _schedule },
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([resourceId, schedule, options]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource.updateSchedule(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'resourceId',
                'schedule',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a resource.
 *
 * The `deleteResource()` function returns a Promise that is resolved when a resource is deleted.
 *
 *
 * Deleting a resource updates its status to `DELETED`.
 *
 * You cannot delete a resource if it has booked sessions.
 *
 *
 * >**Notes:**
 * >- The Bookings app automatically creates a resource with a name and tag of value `"business"`. This resource is used for the business's schedule and working hours and cannot be deleted.
 * >- You can have up to 135 active resources and an additional 135 deleted resources.
 * @param _id - ID of the resource to delete.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @adminMethod
 */
export function deleteResource(_id) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { id: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteResourceRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteResourceResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource._delete(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @param ids - List of resource IDs to delete.
 * @internal
 * @documentationMaturity preview
 * @requiredField ids
 * @adminMethod
 */
export function batchDelete(ids) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { ids: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _batchDeleteResourceRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _batchDeleteResourceResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([ids]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource.batchDelete(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'ids',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Links a resource to a Wix user.
 * The user will be assigned with the `Bookings Staff Member` role, via the `SitePoliciesManagement.AssignPolicies` API.
 *
 * Preconditions:
 * - The resource must not be linked to a user, or an active invite.
 * - The user must be a site contributor
 * - The user must not be linked to another resource.
 *
 * Note:
 * The site owner may be linked to a resource, but will not be assigned with the 'Bookings Staff Member' role.
 * @param resourceId - The id of the resource to link.
 * @param userId - The id of Wix user to link.
 * @internal
 * @documentationMaturity preview
 * @requiredField resourceId
 * @requiredField userId
 * @adminMethod
 */
export function linkResourceToUser(resourceId, userId, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            resourceId: '$[0]',
            userId: '$[1]',
            userEmail: '$[2].userEmail',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[3];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _linkResourceToUserRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _linkResourceToUserResponse,
            depSchemas: {
                _availability,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
            },
            fqdnTransformation: {
                paths: [...['resource']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([resourceId, userId, options]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource.linkResourceToUser(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'resourceId',
                'userId',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Unlink a resource from the site owner.
 * @param resourceId - The id of the resource to unlink.
 * @internal
 * @documentationMaturity preview
 * @requiredField resourceId
 * @adminMethod
 */
export function unLinkResourceFromOwner(resourceId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { resourceId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _unLinkResourceFromOwnerRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _unLinkResourceFromOwnerResponse,
            depSchemas: {
                _availability,
                _location,
                _locationsLocation,
                _resource,
                _schedule,
            },
            fqdnTransformation: {
                paths: [...['resource']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([resourceId]);
        const reqOpts = ambassadorWixBookingsCatalogV1Resource.unLinkResourceFromOwner(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'resourceId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=bookings-catalog-v1-resource.universal.js.map